import { api } from './api';

export interface PublicMaterial {
  readonly materialId: string;
  readonly name: string;
  readonly description: string;
  readonly colorOptions: readonly string[];
  readonly colorStock: Readonly<Record<string, boolean>>;
}

export const materialsApi = {
  list: async (): Promise<readonly PublicMaterial[]> => {
    const result = await api.get<readonly PublicMaterial[]>('/materials');
    return result.data ?? [];
  },
};
